import React from 'react';
import './userGrid.scss';
import ReactTable from 'react-table';
import checkboxHOC from 'react-table/lib/hoc/selectTable';
import 'react-table/react-table.css'

import PropTypes from 'prop-types';
import Moment from 'react-moment';
import {UserType} from '../enum';
import {ExpandedUserRow} from './expandedRow/expandedUserRow';


const CheckboxTable = checkboxHOC(ReactTable);

export class UserGrid extends React.Component {

    static contextTypes = {
        translator: PropTypes.func,
        userList: PropTypes.array,
        selectAll: PropTypes.bool,
        selection: PropTypes.bool,
        multiSelectMode: PropTypes.bool,
        expanded: PropTypes.object,
        toggleSelection: PropTypes.func,
        toggleAll: PropTypes.func,
        isRowDisabled: PropTypes.func
    };

    constructor (props) {
        super(props);
    }

    onToggleSelection (key, shift, row) {
        let selection = [ ...this.props.selection ];
        const selectionKey = row._id;
        const keyIndex = selection.indexOf(selectionKey);

        if (keyIndex >= 0) {
            selection = [
                ...selection.slice(0, keyIndex),
                ...selection.slice(keyIndex + 1)
            ];
        }
        else {
            selection.push(selectionKey);
        }
        this.props.toggleSelection(selection);
    }

    onToggleAll () {
        const selectAll = !this.props.selectAll;
        const selection = [];

        if (selectAll) {
            const reactTableInternals = this.reactTable.getWrappedInstance();
            const currentRecords = reactTableInternals.getResolvedState().sortedData;

            currentRecords.forEach(item => {
                selection.push(item._original._id);
            });
        }

        this.props.toggleAll(selectAll, selection);
    }

    isSelected (key) {
        return this.props.selection.includes(key);
    };

    buildDatagridDrawer (row) {
        return (
            <ExpandedUserRow userDetail={row.row._original}/>
        );
    }

    render () {
        let {
            userList,
            selectAll,
            multiSelectMode,
            isRowDisabled
        } = this.props;

        const emptyGridDataMessage = this.context.translator(`userCenter.grid.data.emptyGridDataMessage`);

        const columns = [
            {
                expander: true,
                Header: () => <span>&nbsp;</span>,
                accessor: 'expander',
                Expander: ({isExpanded, ...rest}) =>
                    <div className="expanderButton">
                        {isExpanded
                            ? <i className="fas fa-chevron-down"></i>
                            : <i className="fas fa-chevron-right"></i>}
                    </div>
            },
            {
                Header: this.context.translator('userCenter.grid.column.name'),
                accessor: 'name',
                Cell: (row) => (<span className="name">{row.value}</span>)
            },
            {
                Header: this.context.translator('userCenter.grid.column.username'),
                accessor: 'username'
            },
            {
                Header: this.context.translator('userCenter.grid.column.userType'),
                accessor: 'userType',
                Cell: (row) => (<span>{this.context.translator(`user.enum.userType.${row.value}`)}</span>)
            },
            {
                Header: this.context.translator('userCenter.grid.column.clientType'),
                accessor: 'clientType'
            },
            {
                Header: this.context.translator('userCenter.grid.column.systemId'),
                accessor: 'systemId'
            },
            {
                Header: this.context.translator('userCenter.grid.column.timeCreated'),
                accessor: 'timeCreated',
                Cell: row => (<Moment format="dddd, MMMM D, YYYY h:mm A">
                    {row.value}
                </Moment>)
            },
            {
                Header: this.context.translator('userCenter.grid.column.organizationName'),
                accessor: 'organizationName'
            }
        ];

        const checkboxProps = {
            selectAll: selectAll,
            isSelected: this.isSelected.bind(this),
            toggleSelection: this.onToggleSelection.bind(this),
            toggleAll: this.onToggleAll.bind(this),
            selectType: 'checkbox'
        };

        const defaultSelectInputComponent = props => {
            const emptyState = {};
            const isDisabled = this.props.isRowDisabled(emptyState, {row: props.row});

            return (
                <input
                    type={props.selectType || 'checkbox'}
                    aria-label={`${props.checked ? 'Un-select' : 'Select'} row with id:${props.id}`}
                    checked={props.checked}
                    disabled={isDisabled.className}
                    id={props.id}
                    onClick={e => {
                        const {shiftKey} = e;
                        e.stopPropagation();
                        props.onClick(props.id, shiftKey, props.row);
                    }}
                    onChange={() => {}}
                />
            )
        };

        const datagrid = (
            <ReactTable
                className="userGrid"
                noDataText={emptyGridDataMessage}
                data={userList}
                columns={columns}
                defaultPageSize={10}
                minRows="0"
                showPageSizeOptions={false}
                SubComponent={row => this.buildDatagridDrawer(row)}
            />
        );

        const multiSelectDatagrid = (
            <CheckboxTable
                className="userGridMultiSelect"
                noDataText={emptyGridDataMessage}
                ref={r => (this.reactTable = r)}
                data={userList}
                columns={columns}
                defaultPageSize={10}
                minRows="0"
                showPageSizeOptions={false}
                SelectInputComponent={defaultSelectInputComponent}
                SubComponent={row => this.buildDatagridDrawer(row)}
                getTdProps={isRowDisabled}
                {...checkboxProps}
            />
        );

        return (
            <div className="userGridComponent ">
                {multiSelectMode ? multiSelectDatagrid : datagrid}
            </div>
        );
    }
}

